"use client";

import { usePathname } from "next/navigation";
import { useQuran, useQuranOptions } from "./providers/QuranContextProvider";
import { useEffect } from "react";
import QuranNavSkelton from "@/components/ui/nav-skeleton";
import QuranPageSkeleton from "@/components/ui/quran-page-skeleton";
import QuranAyahSkeleton from "@/components/ui/quran-ayah-skeleton";

export default function Template({ children }: { children: React.ReactNode }) {
  const { style } = useQuranOptions();
  const { isPageTransitioning, setIsPageTransitioning } = useQuran();
  const path = usePathname();

  useEffect(() => {
    if (!isPageTransitioning) return;

    setIsPageTransitioning(false);
  }, [path]);

  return (
    <>
      {isPageTransitioning ? (
        <>
          {style == "translation" ? (
            <>
              <QuranNavSkelton />
              <QuranAyahSkeleton />
            </>
          ) : (
            <>
              <QuranNavSkelton />
              <QuranPageSkeleton />
            </>
          )}
        </>
      ) : (
        <ChildrenWrapper>{children}</ChildrenWrapper>
      )}
    </>
  );
}

const ChildrenWrapper = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};
